import React from "react";
import { useEffect, useState } from "react";
import { ExportCSVButton } from "../../components/ExportCSVButton";
import { upArrow, downArrow, arrows } from "../../assets/index";
import { FirebaseDataService } from "../../services/firebase-data.service.jsx";
// import { getCookie } from '../../helper/cookie/cookie'
import { useSelector, useDispatch } from "react-redux";
// MongoDB imports
import { getBrowserOSDeviceData, getURL1stLevelData, getURL2ndLevelData, getURLBookingOverallData } from "../../helper/mainPage";
import { LoadingAnimation } from "../../components/Loading/LoadingAnimation";
import {
  setGraph1,
  setGraph2,
  setGraph3,
  setGraph4,
  setGraph1Data,
  setGraph2Data,
  setGraph3Data,
  setGraph4Data,
  setPage1,
  setPage2,
  setPage3,
  setPage4,
} from "./trafficSlice";
import useAuth from "../../helper/CustomHooks/useAuth";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import { getPaidStatus } from "../../helper/Controllers/StatusController.jsx";
import NoDataFound from "../../components/NoDataFound/index.jsx";
import TableLoading from "../../components/Skeletons/TableLoading.jsx";

const firebaseDataService = new FirebaseDataService();

/**
 * Label header for each dataset.
 */
function InformationHeader({
  display,
  labels,
  isReversed,
  setIsReversed,
  allData,
  graphNumber,
}) {
  let currIndex;
  const dispatch = useDispatch();

  function sortColumn(index) {
    // Set current column index to sort
    currIndex = index;

    // If sorted array equals current array, reverse sort
    if (allData[0][index] === allData.slice().sort(sortFunction)[0][index]) {
      switch (graphNumber) {
        case 1:
          dispatch(setGraph1Data([...allData].sort(reverseSortFunction)));
          break;
        case 2:
          dispatch(setGraph2Data([...allData].sort(reverseSortFunction)));
          break;
        case 3:
          dispatch(setGraph3Data([...allData].sort(reverseSortFunction)));
          break;
        default:
          dispatch(setGraph4Data([...allData].sort(reverseSortFunction)));
          break;
      }
    } else {
      switch (graphNumber) {
        case 1:
          dispatch(setGraph1Data([...allData].sort(sortFunction)));
          break;
        case 2:
          dispatch(setGraph2Data([...allData].sort(sortFunction)));
          break;
        case 3:
          dispatch(setGraph3Data([...allData].sort(sortFunction)));
          break;
        default:
          dispatch(setGraph4Data([...allData].sort(sortFunction)));
          break;
      }
    }
    // Change sort arrow on first graph
    if (index === 0) {
      setIsReversed((prev) => !prev);
    }
  }

  function sortFunction(a, b) {
    if (display === "browsers" && currIndex > 2) {
      return a[currIndex] - b[currIndex];
    } else if (display !== "browsers" && currIndex > 0) {
      return a[currIndex] - b[currIndex];
    } else {
      return a[currIndex] < b[currIndex] ? -1 : 1;
    }
  }

  function reverseSortFunction(a, b) {
    if (display === "browsers" && currIndex > 2) {
      return b[currIndex] - a[currIndex];
    } else if (display !== "browsers" && currIndex > 0) {
      return b[currIndex] - a[currIndex];
    } else {
      return b[currIndex] < a[currIndex] ? -1 : 1;
    }
  }

  return (
    <div>
      <div
        className="flex fw-bold align-items-center"
        style={{ width: "100%", fontSize: "13px", height: "40px" }}
      >
        {display === "browsers" ? (
          /*  Graph one labels header */
          <div className="flex align-items-center">
            {/* Browser label */}
            <button
              onClick={() => sortColumn(0)}
              className="flex align-items-center gap-1 ml-1.5"
            >
              {labels[0]}
              <img
                src={isReversed ? upArrow : downArrow}
                alt=""
                className="w-6 mt-0.5"
              />
            </button>
            {/* Operating system label */}
            <button
              onClick={() => sortColumn(1)}
              className="flex align-items-center gap-1 text-nowrap"
              style={{ marginLeft: "330px" }}
            >
              {labels[1]}
              <img src={arrows} alt="" className="w-4 mt-0.5" />
            </button>
            {/* Devices label */}
            <button
              onClick={() => sortColumn(2)}
              className="flex align-items-center gap-1 text-nowrap"
              style={{ marginLeft: "100px", marginRight: "130px" }}
            >
              {labels[2]}
              <img src={arrows} alt="" className="w-4 mt-0.5" />
            </button>
          </div>
        ) : (
          /*  Display === url --> graphs two through four  */
          <div>
            <button
              onClick={() => sortColumn(0)}
              className="flex align-items-center gap-1 ml-1.5"
              style={{ marginRight: "435px" }}
            >
              {labels[0]}
              <img src={arrows} alt="" className="w-4 mt-0.5" />
            </button>
          </div>
        )}
        {/* All date labels for all graphs */}
        {labels.map((value, index) => (
          <button
            key={index}
            onClick={() =>
              sortColumn(display === "browsers" ? index + 3 : index + 1)
            }
            className="flex align-items-center gap-1 text-nowrap"
            style={{ marginRight: "74.6px" }}
          >
            {labels[display === "browsers" ? index + 3 : index + 1]}
            <img src={arrows} alt="" className="w-4 mt-0.5" />
          </button>
        ))}
      </div>
    </div>
  );
}

/**
 * First data table
 */
export function UniqueBrowserOSDevice() {
  const user = useAuth();
  const [paidStatus, setPaidStatus] = useState("loading");

  const [isReversed, setIsReversed] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const dispatch = useDispatch();
  const title = useSelector((state) => state.traffic.graph1.title);
  const labels = useSelector((state) => state.traffic.graph1.labels);
  const allData = useSelector((state) => state.traffic.graph1.allData);
  const page = useSelector((state) => state.traffic.graph1.page);
  const pages = useSelector((state) => state.traffic.graph1.pages);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (title === "" && user) {
          // console.log("🔄 Fetching UniqueBrowserOSDevice data for user:", user);
          
          // === FIREBASE CODE (COMMENTED OUT) ===
          // let statsObj = "";
          // statsObj = user?.split("@")[0] + "/graph-uniqueBrowserOSDevice"; 
          // firebaseDataService
          //   .getStats(statsObj, "tablechart")
          //   .subscribe((data) => {
          //     // ... Firebase processing logic
          //   });
          
          // === MONGODB CODE (ACTIVE) ===
          const mongoData = await getBrowserOSDeviceData(user);
          // console.log("🔄 UniqueBrowserOSDevice MongoDB data:", mongoData);
          
          if (mongoData && mongoData[0] && mongoData[0].length > 0) {
            let browserArray = [];
            let labelArray = [];
            
            // Process MongoDB data to match expected format
            for (let i = 0; i < mongoData[0].length; i++) {
              browserArray[i] = Object.values(mongoData[0][i]);
            }
            
            if (mongoData[0][0]) {
              labelArray = Object.keys(mongoData[0][0]);
            }
            
            // Calculate pagination
            let pageArr = [];
            if (browserArray[0] !== undefined) {
              for (let i = 0; i < Math.ceil(browserArray.length / 15); i++) {
                pageArr[i] = i;
              }
            }
            
            dispatch(
              setGraph1({
                labels: labelArray,
                allData: browserArray,
                title: mongoData[2]?.label || "Browser, OS & Device Data",
                page: 0,
                pages: pageArr,
              })
            );
          } else {
            // console.log("🔄 No UniqueBrowserOSDevice data available");
            dispatch(
              setGraph1({
                labels: [],
                allData: [],
                title: "No Browser, OS & Device Data Available",
                page: 0,
                pages: [],
              })
            );
          }
          setLoading(false);
        }
        
        // Now call the PaidStatus function and wait for its promise to resolve
        const isPaid = await getPaidStatus();
        setPaidStatus(isPaid === true ? "true" : "false");
      } catch (error) {
        console.error("Error fetching UniqueBrowserOSDevice data:", error);
        setLoading(false);
        setPaidStatus("false");
      }
    };
    fetchData();
  }, [user, title, dispatch]);

  function changePage(pageNum) {
    dispatch(setPage1(pageNum));
  }

  if(loading) return <TableLoading/>

  return (
    <div>
      <div className="graph mb-4">
        <div className="graph__title h-16">
          <div className="fw-bold ml-4" style={{ fontSize: "13.5px" }}>
            {title}
          </div>

          {allData.length === 0 || loading ? (
            <div className="csv__button">Export to CSV</div>
          ) : (
            <ExportCSVButton
              allData={[labels, ...allData]}
              name={
                "Share_of_Unique_Visitors_in_Browsers,_Operating_Systems_and_Devices"
              }
            />
          )}
        </div>
        {paidStatus === "loading" ? (
          <LoadingAnimation />
        ) : paidStatus === "true" ? (
          <div>
            <div className="p-3">
              {loading ? (
                <LoadingAnimation />
              ) : (
                <div
                  className="flex flex-col"
                  style={{
                    border: "1px solid rgba(0,0,0,0.1)",
                    overflowX: "scroll",
                  }}
                >
                  <InformationHeader
                    display={"browsers"}
                    labels={labels}
                    isReversed={isReversed}
                    setIsReversed={setIsReversed}
                    allData={allData}
                    graphNumber={1}
                    graphID={"traffic-chart1"}
                  />

                  {allData.map((value, index) => (
                    <div key={index} id={"traffic-chart1"}>
                      {/* Only display 15 rows depending on curr page */}
                      {index >= page * 15 && index < (page + 1) * 15 ? (
                        <div
                          className="flex"
                          style={{
                            fontSize: "12px",
                            borderTop: "1.5px solid rgba(0,0,0,0.1)",
                            width: "4400px",
                          }}
                        >
                          {/* Browsers */}
                          <div
                            className="pt-2.5 pb-2 pl-1.5 traffic__item"
                            style={{ minWidth: "382px", maxWidth: "382px" }}
                          >
                            {value[0]}
                          </div>
                          {/* Operating Systems */}
                          <div
                            className="pt-2.5 pb-2 pl-1.5 traffic__item"
                            style={{
                              wordWrap: "break-word",
                              minWidth: "214px",
                              maxWidth: "214px",
                            }}
                          >
                            {value[1]}
                          </div>
                          {/* Devices */}
                          <div
                            className="pt-2.5 pb-2 pl-1.5 traffic__item"
                            style={{
                              wordWrap: "break-word",
                              minWidth: "175px",
                              maxWidth: "175px",
                            }}
                          >
                            {value[2]}
                          </div>
                          {/* All numbers */}
                          {value.map((week, index) => (
                            <div key={index}>
                              <div
                                className="pt-2.5 pb-2 pl-1.5 traffic__item"
                                style={{
                                  minWidth: `${
                                    index < value.length - 3 ? "150px" : "0px"
                                  }`,
                                }}
                              >
                                {value[index + 3]}
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <Pagination
              page={page}
              pages={pages}
              changePage={changePage}
              graphID={"traffic-chart1"}
            />
          </div>
        ) : (
          <NoDataFound />
        )}
      </div>
    </div>
  );
}

/**
 * Second data table
 */
export function UniqueURL1stLevelDirLoaded() {
  const user = useAuth();
  const [paidStatus, setPaidStatus] = useState("loading");

  const [isReversed, setIsReversed] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const dispatch = useDispatch();
  const title = useSelector((state) => state.traffic.graph2.title);
  const labels = useSelector((state) => state.traffic.graph2.labels);
  const allData = useSelector((state) => state.traffic.graph2.allData);
  const page = useSelector((state) => state.traffic.graph2.page);
  const pages = useSelector((state) => state.traffic.graph2.pages);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (title === "" && user) {
          // console.log("🔄 Fetching UniqueURL1stLevel data for user:", user);
          
          // === FIREBASE CODE (COMMENTED OUT) ===
          // let statsObj = "";
          // statsObj = user?.split("@")[0] + "/graph-uniqueURL1stLevelDir"; 
          // firebaseDataService
          //   .getStats(statsObj, "tablechart")
          //   .subscribe((data) => {
          //     // ... Firebase processing logic
          //   });
          
          // === MONGODB CODE (ACTIVE) ===
          const mongoData = await getURL1stLevelData(user);
          // console.log("🔄 UniqueURL1stLevel MongoDB data:", mongoData);
          
          if (mongoData && mongoData[0] && mongoData[0].length > 0) {
            let browserArray = [];
            let labelArray = [];
            
            // Process MongoDB data to match expected format
            for (let i = 0; i < mongoData[0].length; i++) {
              browserArray[i] = Object.values(mongoData[0][i]);
            }
            
            if (mongoData[0][0]) {
              labelArray = Object.keys(mongoData[0][0]);
            }
            
            // Calculate pagination
            let pageArr = [];
            if (browserArray[0] !== undefined) {
              for (let i = 0; i < Math.ceil(browserArray.length / 15); i++) {
                pageArr[i] = i;
              }
            }
            
            dispatch(
              setGraph2({
                labels: labelArray,
                allData: browserArray,
                title: mongoData[2]?.label || "URL 1st Level Directory Data",
                page: 0,
                pages: pageArr,
              })
            );
          } else {
            // console.log("🔄 No UniqueURL1stLevel data available");
            dispatch(
              setGraph2({
                labels: [],
                allData: [],
                title: "No URL 1st Level Data Available",
                page: 0,
                pages: [],
              })
            );
          }
          setLoading(false);
        }
        
        // Now call the PaidStatus function and wait for its promise to resolve
        const isPaid = await getPaidStatus();
        setPaidStatus(isPaid === true ? "true" : "false");
      } catch (error) {
        console.error("Error fetching UniqueURL1stLevel data:", error);
        setLoading(false);
        setPaidStatus("false");
      }
    };
    fetchData();
  }, [user, title, dispatch]);

  function changePage(pageNum) {
    dispatch(setPage2(pageNum));
  }

  if(loading) return <TableLoading/>

  return (
    <div>
      <div className="graph mb-4">
        <div className="graph__title h-16">
          <div className="fw-bold ml-4" style={{ fontSize: "13.5px" }}>
            {title}
          </div>
          {allData.length === 0 || loading ? (
            <div className="csv__button">Export to CSV</div>
          ) : (
            <ExportCSVButton
              allData={[labels, ...allData]}
              name={"Share_of_Unique_Visitors_among_URLs"}
            />
          )}
        </div>
        {paidStatus === "loading" ? (
          <LoadingAnimation />
        ) : paidStatus === "true" ? (
          <div>
            {loading ? (
              <LoadingAnimation />
            ) : (
              <UrlFormat
                labels={labels}
                allData={allData}
                isReversed={isReversed}
                setIsReversed={setIsReversed}
                graphNumber={2}
                page={page}
                graphID={"traffic-graph2"}
              />
            )}

            <Pagination
              page={page}
              pages={pages}
              changePage={changePage}
              graphID={"traffic-graph2"}
            />
          </div>
        ) : (
          <NoDataFound />
        )}
      </div>
    </div>
  );
}

/**
 * Third data table
 */
export function UniqueURL2ndLevelDirLoaded() {
  const user = useAuth();
  const [paidStatus, setPaidStatus] = useState("loading");

  const [isReversed, setIsReversed] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const dispatch = useDispatch();
  const title = useSelector((state) => state.traffic.graph3.title);
  const labels = useSelector((state) => state.traffic.graph3.labels);
  const allData = useSelector((state) => state.traffic.graph3.allData);
  const page = useSelector((state) => state.traffic.graph3.page);
  const pages = useSelector((state) => state.traffic.graph3.pages);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (title === "" && user) {
          // console.log("🔄 Fetching UniqueURL2ndLevel data for user:", user);
          
          // === FIREBASE CODE (COMMENTED OUT) ===
          // let statsObj = "";
          // statsObj = user?.split("@")[0] + "/graph-uniqueURL2ndLevelDir"; 
          // firebaseDataService
          //   .getStats(statsObj, "tablechart")
          //   .subscribe((data) => {
          //     // ... Firebase processing logic
          //   });
          
          // === MONGODB CODE (ACTIVE) ===
          const mongoData = await getURL2ndLevelData(user);
          // console.log("🔄 UniqueURL2ndLevel MongoDB data:", mongoData);
          
          if (mongoData && mongoData[0] && mongoData[0].length > 0) {
            let browserArray = [];
            let labelArray = [];
            
            // Process MongoDB data to match expected format
            for (let i = 0; i < mongoData[0].length; i++) {
              browserArray[i] = Object.values(mongoData[0][i]);
            }
            
            if (mongoData[0][0]) {
              labelArray = Object.keys(mongoData[0][0]);
            }
            
            // Calculate pagination
            let pageArr = [];
            if (browserArray[0] !== undefined) {
              for (let i = 0; i < Math.ceil(browserArray.length / 15); i++) {
                pageArr[i] = i;
              }
            }
            
            dispatch(
              setGraph3({
                labels: labelArray,
                allData: browserArray,
                title: mongoData[2]?.label || "URL 2nd Level Directory Data",
                page: 0,
                pages: pageArr,
              })
            );
          } else {
            // console.log("🔄 No UniqueURL2ndLevel data available");
            dispatch(
              setGraph3({
                labels: [],
                allData: [],
                title: "No URL 2nd Level Data Available",
                page: 0,
                pages: [],
              })
            );
          }
          setLoading(false);
        }
        
        // Now call the PaidStatus function and wait for its promise to resolve
        const isPaid = await getPaidStatus();
        setPaidStatus(isPaid === true ? "true" : "false");
      } catch (error) {
        console.error("Error fetching UniqueURL2ndLevel data:", error);
        setLoading(false);
        setPaidStatus("false");
      }
    };
    fetchData();
  }, [user, title, dispatch]);

  function changePage(pageNum) {
    dispatch(setPage3(pageNum));
  }

  if(loading) return <TableLoading/>

  return (
    <div className="graph mb-4">
      <div className="graph__title h-16">
        <div className="fw-bold ml-4" style={{ fontSize: "13.5px" }}>
          {title}
        </div>
        {allData.length === 0 || loading ? (
          <div className="csv__button">Export to CSV</div>
        ) : (
          <ExportCSVButton
            allData={[labels, ...allData]}
            name={"Share_of_Unique_Visitors_among_Second_Level_URLs"}
          />
        )}
      </div>
      {paidStatus === "loading" ? (
        <LoadingAnimation />
      ) : paidStatus === "true" ? (
        <>
          {loading ? (
            <LoadingAnimation />
          ) : (
            <UrlFormat
              labels={labels}
              allData={allData}
              isReversed={isReversed}
              setIsReversed={setIsReversed}
              graphNumber={3}
              page={page}
              graphID={"traffic-graph3"}
            />
          )}
          <Pagination
            page={page}
            pages={pages}
            changePage={changePage}
            graphID={"traffic-graph3"}
          />
        </>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
}

/**
 * Fourth data table
 */
export function UniqueURLbookInProOverall() {
  const user = useAuth();
  const [paidStatus, setPaidStatus] = useState("loading");

  const [isReversed, setIsReversed] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  const dispatch = useDispatch();
  const title = useSelector((state) => state.traffic.graph4.title);
  const labels = useSelector((state) => state.traffic.graph4.labels);
  const allData = useSelector((state) => state.traffic.graph4.allData);
  const page = useSelector((state) => state.traffic.graph4.page);
  const pages = useSelector((state) => state.traffic.graph4.pages);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (title === "" && user) {
          // console.log("🔄 Fetching UniqueURLBookingOverall data for user:", user);
          
          // === FIREBASE CODE (COMMENTED OUT) ===
          // let statsObj = "";
          // statsObj = user?.split("@")[0] + "/graph-uniqueURLbookInProOverall"; 
          // firebaseDataService
          //   .getStats(statsObj, "tablechart")
          //   .subscribe((data) => {
          //     // ... Firebase processing logic
          //   });
          
          // === MONGODB CODE (ACTIVE) ===
          const mongoData = await getURLBookingOverallData(user);
          // // console.log("🔄 UniqueURLBookingOverall MongoDB data:", mongoData);
          
          if (mongoData && mongoData[0] && mongoData[0].length > 0) {
            let browserArray = [];
            let labelArray = [];
            
            // Process MongoDB data to match expected format
            for (let i = 0; i < mongoData[0].length; i++) {
              browserArray[i] = Object.values(mongoData[0][i]);
            }
            
            if (mongoData[0][0]) {
              labelArray = Object.keys(mongoData[0][0]);
            }
            
            // Calculate pagination
            let pageArr = [];
            if (browserArray[0] !== undefined) {
              for (let i = 0; i < Math.ceil(browserArray.length / 15); i++) {
                pageArr[i] = i;
              }
            }
            
            dispatch(
              setGraph4({
                labels: labelArray,
                allData: browserArray,
                title: mongoData[2]?.label || "URL Booking Overall Data",
                page: 0,
                pages: pageArr,
              })
            );
          } else {
            // // console.log("🔄 No UniqueURLBookingOverall data available");
            dispatch(
              setGraph4({
                labels: [],
                allData: [],
                title: "No URL Booking Overall Data Available",
                page: 0,
                pages: [],
              })
            );
          }
          setLoading(false);
        }
        
        // Now call the PaidStatus function and wait for its promise to resolve
        const isPaid = await getPaidStatus();
        setPaidStatus(isPaid === true ? "true" : "false");
      } catch (error) {
        console.error("Error fetching UniqueURLBookingOverall data:", error);
        setLoading(false);
        setPaidStatus("false");
      }
    };
    fetchData();
  }, [user, title, dispatch]);

  function changePage(pageNum) {
    dispatch(setPage4(pageNum));
  }

  if(loading) return <TableLoading/>

  return (
    <div className="graph mb-4">
      <div className="graph__title h-16">
        <div className="fw-bold ml-4" style={{ fontSize: "13.5px" }}>
          {title}
        </div>

        {allData.length === 0 || loading ? (
          <button className="csv__button">Export to CSV</button>
        ) : (
          <ExportCSVButton
            allData={[labels, ...allData]}
            name={
              "%_Overall_URL_Visit_Distribution_of_Users_that_Started_Booking"
            }
          />
        )}
      </div>
      {paidStatus === "loading" ? (
        <LoadingAnimation />
      ) : paidStatus === "true" ? (
        <>
          {loading ? (
            <LoadingAnimation />
          ) : (
            <UrlFormat
              labels={labels}
              allData={allData}
              isReversed={isReversed}
              setIsReversed={setIsReversed}
              graphNumber={4}
              page={page}
              graphID={"traffic-graph4"}
            />
          )}

          <Pagination
            page={page}
            pages={pages}
            changePage={changePage}
            graphID={"traffic-graph4"}
          />
        </>
      ) : (
        <NoDataFound />
      )}
    </div>
  );
}

/**
 * Data table component for graphs 2-4
 */
function UrlFormat({
  labels,
  allData,
  isReversed,
  setIsReversed,
  graphNumber,
  page,
  graphID,
}) {
  return (
    <div className="p-3">
      <div
        className="flex flex-col"
        style={{ border: "1px solid rgba(0,0,0,0.1)", overflowX: "scroll" }}
        id={graphID}
      >
        <InformationHeader
          display={"url"}
          labels={labels}
          isReversed={isReversed}
          setIsReversed={setIsReversed}
          allData={allData}
          graphNumber={graphNumber}
        />

        {allData.map((value, index) => (
          <div key={index}>
            {/* Only display 15 rows depending on curr page */}
            {index >= page * 15 && index < (page + 1) * 15 ? (
              <div
                className="flex"
                style={{
                  fontSize: "12px",
                  borderTop: "1px solid rgba(0,0,0,0.1)",
                  width: "4100px",
                }}
              >
                {/* Browsers */}
                <div
                  className="pt-2.5 pb-2 pl-1.5 traffic__item"
                  style={{ minWidth: "465px", maxWidth: "465px" }}
                >
                  {value[0]}
                </div>
                {/* All numbers */}
                {value.map((week, index) => (
                  <div key={index}>
                    <div
                      className="pt-2.5 pb-2 pl-1.5 traffic__item"
                      style={{
                        minWidth: `${
                          index < value.length - 3 ? "150px" : "0px"
                        }`,
                      }}
                    >
                      {value[index + 1]}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function Pagination({ page, pages, changePage, graphID }) {
  console.log(
    graphID,
    pages.length * 15 + "from " + +page * 15 + " to " + (+page * 15 + 15)
  );
  return (
    <div className="pagination__component flex justify-between px-3 mb-4 text-xs">
      <p className="pagination__text">{`Showing ${+page * 15} to ${
        +page * 15 + 15
      } of ${pages.length * 15} results`}</p>
      <div className="pagination__container flex font-bold">
        {/* Left arrow */}
        <button
          title="Left Arrow"
          className={`pagination__item pagination__arrow rounded-tl-lg rounded-bl-lg ${
            page === 0 ? "pagination__inactive" : ""
          } `}
          onClick={() => {
            if (page !== 0) {
              changePage(page - 1);
              document.getElementById(graphID).scrollIntoView(true);
            }
          }}
        >
          <AiOutlineLeft />
        </button>

        {/* Ellipses */}
        {pages.length > 5 && page > 2 && (
          <div className="pagination__item pt-1.5">...</div>
        )}

        {/* Page numbers */}
        {pages.length > 5 ? (
          <div className="flex">
            {pages
              .slice(
                page > 2
                  ? page === pages.length - 1
                    ? page - 4
                    : page === pages.length - 2
                    ? page - 3
                    : page - 2
                  : 0,
                page < pages.length - 3
                  ? page === 0
                    ? page + 5
                    : page === 1
                    ? page + 4
                    : page + 3
                  : pages.length
              )
              .map((value, index) => (
                <button
                  key={index}
                  className={`pagination__item ${
                    page === value ? "pagination__selected" : ""
                  }`}
                  onClick={() => {
                    changePage(value);
                    document.getElementById(graphID).scrollIntoView(true);
                  }}
                >
                  {value + 1}
                </button>
              ))}
          </div>
        ) : (
          <div className="flex">
            {pages.map((value, index) => (
              <button
                key={index}
                className={`pagination__item ${
                  page === value ? "pagination__selected" : ""
                }`}
                onClick={() => {
                  changePage(value);
                  document.getElementById(graphID).scrollIntoView(true);
                }}
              >
                {value + 1}
              </button>
            ))}
          </div>
        )}

        {/* Ellipses */}
        {pages.length > 5 && page < pages.length - 3 && (
          <div className="pagination__item pt-1.5">...</div>
        )}

        {/* Right arrow */}
        <button
          title="Right Arrow"
          className={`pagination__item pagination__arrow rounded-tr-lg rounded-br-lg ${
            page === pages.length - 1 ? "pagination__inactive" : ""
          } `}
          onClick={() => {
            if (page !== pages.length - 1) {
              changePage(page + 1);
              document.getElementById(graphID).scrollIntoView(true);
            }
          }}
        >
          <AiOutlineRight />
        </button>
      </div>
    </div>
  );
}
